import { useCookies } from './useCookies';

export function useGtag() {
  const { get } = useCookies();

  const updateGtagConsent = (granted: boolean) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: granted ? 'granted' : 'denied',
      });
    }
  };

  const initializeGtagConsent = () => {
    const hasAnalytics = get('cookieconsent_analytics') === '1';
    updateGtagConsent(hasAnalytics);
  };

  return {
    initializeGtagConsent,
    updateGtagConsent,
  };
}
